import { Event as AmplitudeEvent, Result } from '@amplitude/analytics-types';

import { getConfigValue, googleTagManagerScriptId } from '../environment';

export async function initGoogleTagManager() {
  const gtmContainerId = getConfigValue('googleTagManager').containerId;

  if (!gtmContainerId) {
    return;
  }

  const scriptId = googleTagManagerScriptId();

  (function (w, d, l, i) {
    const existing = d.querySelectorAll(`script#${scriptId}`);

    if (existing.length > 0) {
      return;
    }

    w[l] = w[l] || [];
    w[l].push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    });

    const f = d.getElementsByTagName('script')[0];
    const j = d.createElement('script');
    const dl = l !== 'dataLayer' ? '&l=' + l : '';

    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    j.id = scriptId;

    if (f && f.parentNode) {
      f.parentNode.insertBefore(j, f);
    } else {
      d.body.appendChild(j);
    }
  })(window, document, 'dataLayer', gtmContainerId);
}

export async function sendGoogleTagManagerEvent(event: AmplitudeEvent): Promise<Result> {
  window.dataLayer.push({
    event: event.event_type,
    ...event,
  });

  return {
    code: 200,
    event,
    message: 'Event pushed onto GTM Data Layer',
  };
}
